import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-outward-transaction',
  templateUrl: './outward-transaction.component.html',
  styleUrls: ['./outward-transaction.component.scss']
})
export class OutwardTransactionComponent implements OnInit {

  static that: OutwardTransactionComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;
  @Input() shipmentModetypearray: any = [];
  @Input() parentTypearray: any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
  ) {
    OutwardTransactionComponent.that = this;
  }

  ngOnInit() {
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);


    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');

    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['Id']) {
    //   this.Id = changes['Id'].currentValue;
    //   if (this.Id) {
    //     this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
    //   }
    // }

    if (changes['Id']) {
      this.Id = changes['Id'].currentValue;
      if (changes['shipmentModetypearray']) {
        this.shipmentModetypearray = changes['shipmentModetypearray'].currentValue;
      }
      if (changes['parentTypearray']) {
        this.parentTypearray = changes['parentTypearray'].currentValue;
      }
    }


  }

  async initalizeForm() {
    this.tableDetails = {
      emptyDataMSg: "No Records Found.",
      isColumnNameShow: true,
      data: [],
      columnDetails: [
        { columnName: "Outward No", dataFieldName: "OrderNo", dataFieldName2: "OrderDate", divType: "ftlOrders", color: "var(--colors-primary-blue-blue-200, #3367FB)" },
        { columnName: "Order", dataFieldName: "SONo", dataFieldName2: "ParentOrderType", dataFieldName3: "SODate", divType: "ftlOrders", color: "var(--colors-primary-blue-blue-200, #3367FB)" },
        { columnName: "Invoice No", dataFieldName: "InvoiceNo", divType: "ftlOrders", color: "var(--colors-primary-blue-blue-200, #3367FB)" },
        { columnName: "Customer", dataFieldName: "Customer", dataFieldName2: "PickupLocationCode" },
        { columnName: "Ship To Party", dataFieldName: "ShipTo", dataFieldName2: "DeliveryLocationCode" },
        { columnName: "Qty in Case", dataFieldName: "QtyCase", divType: "" },
        { columnName: 'Total Qty', dataFieldName: 'totalQty', divType: '', alignType: 'right' },
        { columnName: "Weight", dataFieldName: "Weight", alignType: "right", divType: "" },
        { columnName: "Amount", dataFieldName: "Amount", alignType: "right", divType: "" },
        { columnName: "Status", dataFieldName: "OrderStatus", divType: "status" },
      ],
    }
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
        this.GetTransactionList('', 0, {}, this.noOfPages, this.Id, this.CompanyId)
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {

    Helpers.setLoading(true);

    if (CompanyId !== undefined && CompanyId !== null) {
      this.CompanyId = CompanyId;
    }

    localStorage.setItem('perPage', perPage);
    // this.payload.Start = pageNo * perPage;
    // this.payload.Length = perPage;
    // this.payload.SearchValue = searchValue;
    // this.payload.CompanyId = this.CompanyId;
    // this.payload.FromDate = this.data.FromDate;
    // this.payload.ToDate = this.data.ToDate;
    // this.payload.Id = Id;
    // this.payload.ReferenceType = this.referenceType;

    this.payload.Start = pageNo * perPage;
    this.payload.PerPage = perPage;
    this.payload.SearchValue = searchValue || null;
    this.payload.userId = this.userId;
    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
    this.payload.OrderNo = null;

    if (this.shipmentModetypearray.includes('customer') || this.shipmentModetypearray.includes('general trade') || this.shipmentModetypearray.includes('modern trade') || this.parentTypearray.includes('customer') || this.parentTypearray.includes('manufacturer')) {
      this.payload.CustomerName = Id ? Id : this.Id;
    }
    else {
      this.payload.CustomerName = null;
    }

    this.payload.ShipTo = null;
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null;

    if (this.shipmentModetypearray.includes('vendor') || this.shipmentModetypearray.includes('road freight') || this.shipmentModetypearray.includes('transporter')) {
      this.payload.transporterId = Id ? Id : this.Id;
    }
    else {
      this.payload.transporterId = null;
    }

    if (this.referenceType == 'Users') {
      this.payload.salesPersonId = Id ? Id : this.Id;
    }
    else {
      this.payload.salesPersonId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("so_GoodsOutward", "so_getGoodOutwardList", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].recordcount;
        // this.isListApiCalled = true;
      }
      this.assignTableFields(pageNo, perPage, response);
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }


  GetTransactionListDownload(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id
  ) {
    Helpers.setLoading(true);

    this.payload.Start = pageNo;
    this.payload.PerPage = this.totalCount;
    this.payload.SearchValue = searchValue;
    this.payload.userId = this.userId;
    this.payload.CompanyId = this.CompanyId;
    this.payload.OrderNo = null;

    if (this.shipmentModetypearray.includes('customer') || this.shipmentModetypearray.includes('general trade') || this.shipmentModetypearray.includes('modern trade') || this.parentTypearray.includes('customer') || this.parentTypearray.includes('manufacturer')) {
      this.payload.CustomerName = Id ? Id : this.Id;
    }
    else {
      this.payload.CustomerName = null;
    }

    this.payload.ShipTo = null;
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null;

    if (this.shipmentModetypearray.includes('vendor') || this.shipmentModetypearray.includes('road freight') || this.shipmentModetypearray.includes('transporter')) {
      this.payload.transporterId = Id ? Id : this.Id;
    }
    else {
      this.payload.transporterId = Id ? Id : this.Id;
    }

    if (this.referenceType == 'Users') {
      this.payload.salesPersonId = Id ? Id : this.Id;
    }
    else {
      this.payload.salesPersonId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("so_GoodsOutward", "GoodsOutwardDownload", this.payload).subscribe((response) => {
      this.DownloadFile(response);
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while downloading", error);
      }
    );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

}
